const Yantra = document.createElement('DIV');
Yantra.setAttribute('id', 'yantra');

export default Yantra;
